import React, { useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import s from './index.module.scss';
import common from '../../index.module.scss';
import video2Male from './media/2_male.mp4';
import poster2Male from './media/posters/2_male.jpg';
import questions from '../../../surveyMan/questionsMan';

function PushUps () {
	const { T } = useT();
	const userAge = Object.keys(
		questions.getAnswers({
			questionName: 'age'
		})
	).toString();
	let firstBtn;
	let secondBtn;
	let thirdBtn;
	let fourthBtn;
	let level;

	switch (userAge) {
	case '18-29':
		firstBtn = '0-16';
		secondBtn = '17-29';
		thirdBtn = '30+';
		fourthBtn = 'I don’t know';
		break;
	case '30-39':
		firstBtn = '0-12';
		secondBtn = '13-24';
		thirdBtn = '25+';
		fourthBtn = 'I don’t know';

		break;
	case '40-49':
		firstBtn = '0-10';
		secondBtn = '11-20';
		thirdBtn = '21+';
		fourthBtn = 'I don’t know';
		break;
	case '50-59+':
		firstBtn = '0-5';
		secondBtn = '6-16';
		thirdBtn = '17+';
		fourthBtn = 'I don’t know';
		break;
	default:
		firstBtn = '0-15';
		secondBtn = '16-30';
		thirdBtn = '30+';
		fourthBtn = 'I don’t know';
		break;
	}

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'pushUps',
			stepStatus: true
		});
	});

	function actionOnClick (e) {
		switch (e.target.id) {
		case '1':
			level = 'beginner';
			break;
		case '2':
			level = 'intermediate';
			break;
		case '3':
			level = 'advanced';
			break;
		default:
			level = 'beginner';
		}

		questions.setAnswer({
			questionName: 'current_level',
			answerName: level,
			answerValue: { value: level }
		});

		setTimeout(() => {
			steps.navigate.forward({
				preventAction: 500
			});
		}, 300);
	}

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>{T('pushUps_title')}</h1>
			<div className={common.stepDescription}>{T('pushUps_description')}</div>
			<div className={s.videoWrapper}>
				<div className={s.subVideoWrapper} data-video="0">
					<div className={s.loader} />
					<video
						id="workoutsPreferenciesVideo"
						className={`${s.video}`}
						muted
						autoPlay
						loop
						playsInline
						preload="auto"
						poster={poster2Male}
					>
						<source src={`${video2Male}#t=0.0001`} type="video/mp4" />
					</video>
				</div>
			</div>
			<div className={s.actions}>
				<button onClick={e => actionOnClick(e)} className={s.action} id="1" type="button">
					<span className={s.symbol}>{firstBtn}</span>
				</button>
				<button onClick={e => actionOnClick(e)} className={s.action} id="2" type="button">
					<span className={s.symbol}>{secondBtn}</span>
				</button>
				<button onClick={e => actionOnClick(e)} className={s.action} id="3" type="button">
					<span className={s.symbol}>{thirdBtn}</span>
				</button>
				<button onClick={e => actionOnClick(e)} className={s.action} id="4" type="button">
					<span className={s.symbol}>{fourthBtn}</span>
				</button>
			</div>
		</div>
	);
}

export default PushUps;
